import { render, staticRenderFns } from "./TransferOwnerShip.vue?vue&type=template&id=9377a8a6&scoped=true"
import script from "./TransferOwnerShip.vue?vue&type=script&lang=js"
export * from "./TransferOwnerShip.vue?vue&type=script&lang=js"
import style0 from "./TransferOwnerShip.vue?vue&type=style&index=0&id=9377a8a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9377a8a6",
  null
  
)

export default component.exports